export const BRAND_NAME = 'Grih Upvan';
export const BRAND_INITIALS = 'GU';
export const BRAND_TAGLINE = 'Bring nature home';

export const brandTitle = (title?: string): string =>
  title ? `${title} - ${BRAND_NAME}` : `${BRAND_NAME} - ${BRAND_TAGLINE}`;
